import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider, useAuth } from './context/AuthContext';

import Navbar from './components/Navbar';
import SiteFooter from './components/SiteFooter';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderConfirmation from './pages/OrderConfirmation';
import Tracking from './pages/Tracking';
import Support from './pages/Support';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminProducts, { ProductForm } from './pages/AdminProducts';
import AdminOrders from './pages/AdminOrders';
import AdminSupport from './pages/AdminSupport';
import AdminPromotions from './pages/AdminPromotions';
import AdminSecurity from './pages/AdminSecurity';

// ── Protected route wrapper ───────────────────────────────────────────────────
function AdminRoute({ children }) {
  const { admin } = useAuth();
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

// ── Layout wrapper (with navbar) ──────────────────────────────────────────────
function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <SiteFooter />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Routes>
            {/* Public storefront */}
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/product/:id" element={<Layout><ProductDetail /></Layout>} />
            <Route path="/cart" element={<Layout><Cart /></Layout>} />
            <Route path="/checkout" element={<Layout><Checkout /></Layout>} />
            <Route path="/order/:orderNumber" element={<Layout><OrderConfirmation /></Layout>} />
            <Route path="/track" element={<Layout><Tracking /></Layout>} />
            <Route path="/support" element={<Layout><Support /></Layout>} />
            <Route path="/privacy" element={<Layout><PrivacyPolicy /></Layout>} />
            <Route path="/terms" element={<Layout><Terms /></Layout>} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminRoute><Layout><AdminDashboard /></Layout></AdminRoute>} />
            <Route path="/admin/products" element={<AdminRoute><Layout><AdminProducts /></Layout></AdminRoute>} />
            <Route path="/admin/products/new" element={<AdminRoute><Layout><ProductForm /></Layout></AdminRoute>} />
            <Route path="/admin/products/edit/:id" element={<AdminRoute><Layout><ProductForm /></Layout></AdminRoute>} />
            <Route path="/admin/orders" element={<AdminRoute><Layout><AdminOrders /></Layout></AdminRoute>} />
            <Route path="/admin/support" element={<AdminRoute><Layout><AdminSupport /></Layout></AdminRoute>} />
            <Route path="/admin/promotions" element={<AdminRoute><Layout><AdminPromotions /></Layout></AdminRoute>} />
            <Route path="/admin/security" element={<AdminRoute><Layout><AdminSecurity /></Layout></AdminRoute>} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
